import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Observable} from 'rxjs';
import {TtsControlEnum} from '@core/enums/tts-control.enum';
import {createClickEventForPopUp} from '../../helpers/helper-popup';
import {AbstractDialogModel} from '@shared/dialogs/model/abstract-dialog.model';
import {UnitARequestModel} from '@core/modules/rest/consent/request/unit-a-request.model';
import {CommentBasicModel} from '@core/modules/rest/consent/response/comment-basic.model';
import {OutlineCommentsEnum} from '@core/enums/outline-comments.enum';
import {LanguageEnum} from '@core/enums/language.enum';
import {LanguageStyleEnum} from '@core/enums/language-style.enum';
import {PresentationModeEnum} from '@core/enums/presentation-mode.enum';

@Component({
    selector: 'app-display-consent-header',
    templateUrl: './display-consent-header.component.html',
    styleUrls: ['./display-consent-header.component.scss']
})
export class DisplayConsentHeaderComponent implements OnChanges {
    @Input() activeOutlineTab: number | undefined;
    @Input() comments: CommentBasicModel[] | undefined;
    @Input() indicationTitle: string;
    @Input() informationUnitTitle: string;
    @Input() repeatButtonDisabled = true;
    @Input() stopAudio: Observable<void> = new Observable<void>();
    @Input() submittedConsentId?: string;
    @Input() language?: LanguageEnum;
    @Input() languageStyle?: LanguageStyleEnum;
    @Input() presentationMode?: PresentationModeEnum;
    @Input() reviewerMode: boolean;
    @Input() selectedIndication?: string;
    @Input() selectedUseCase?: string;
    @Input() showHeaderControls: boolean | undefined;
    @Input() showBackButton: boolean | undefined;
    @Input() backButtonText: string | undefined;
    @Input() chapterUseCases: UnitARequestModel[] = [];
    @Input() ttsIconState: TtsControlEnum | undefined;
    @Input() enableCommenting: boolean | undefined;
    @Input() enableSettings: boolean | undefined;
    @Output() emitControls: EventEmitter<string> = new EventEmitter<string>();
    @Output() openDialog: EventEmitter<AbstractDialogModel> = new EventEmitter();
    @Output() leaveIndication: EventEmitter<void> = new EventEmitter();
    @Output() toggleMenu = new EventEmitter<OutlineCommentsEnum>();
    @Output() playFromStartAudioEvent: EventEmitter<void> = new EventEmitter();
    @Output() pauseAudioEvent: EventEmitter<void> = new EventEmitter();
    @Output() readTextEvent: EventEmitter<void> = new EventEmitter();
    @Output() backEvent = new EventEmitter<void>();

    languageGerman = LanguageEnum.GERMAN;
    playState = TtsControlEnum.playState;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.informationUnitTitle && this.informationUnitTitle) {
            // TODO This should probably be refactored at some point, I couldn't find anything useful around this in the docs (Vukasin)
            setTimeout(() => {
                const h2Tag: any = document.querySelector('.header-info__unit-title');
                h2Tag.innerHTML = this.informationUnitTitle;
                const popUpHeader = document.querySelectorAll('.content__header .popUpLink');
                createClickEventForPopUp(popUpHeader, this.openDialog, this.selectedIndication);
            });
        }
    }

    getBack(): void {
        this.pauseAudioEvent.emit();
        this.backEvent.emit();
    }

    openMenu(menu: string): void {
        const menuEnum = menu as OutlineCommentsEnum;
        this.toggleMenu.emit(menuEnum);
    }

    playFromStart(): void {
        this.playFromStartAudioEvent.emit();
    }

    readText(): void {
        this.readTextEvent.emit();
    }
}
